export class AreaEnergyModel {
    public profile_enabled: any[] = []; 
    public cdc_associated = [];
    public enable_disabled : any;
    public hold: boolean;
    public notes: string; 
}
